import React from "react";
import { cn } from "../../../lib/utils";

const statusStyles = {
  ACTIVE: "bg-amber-100 text-amber-900 border-amber-200/80",
  COMPLETED: "bg-emerald-100 text-emerald-800 border-emerald-200/80",
  ARCHIVED: "bg-rose-100 text-rose-800 border-rose-200/80",
};

export function TestPlanStatusBadge({ status, className }) {
  const s = (status || "").toUpperCase();
  const label =
    s === "ARCHIVED" ? "Archive" : s === "COMPLETED" ? "Completed" : "Active";
  return (
    <span
      data-testid="test-plan-status-badge"
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold",
        statusStyles[s] || "bg-gray-100 text-gray-800 border-gray-200",
        className,
      )}
    >
      {label}
    </span>
  );
}
